<table mat-table [dataSource]="rowArray()">
  @for (col of displayedColumns(); track $index) {
    <ng-container [matColumnDef]="col.key">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.label }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="skeleton"></div>
      </td>
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="keys()"></tr>
  <tr mat-row *matRowDef="let row; columns: keys()"></tr>
</table>
